import { render, staticRenderFns } from "./FinanceModule.vue?vue&type=template&id=4667c853&scoped=true&"
import script from "./FinanceModule.vue?vue&type=script&lang=js&"
export * from "./FinanceModule.vue?vue&type=script&lang=js&"
import style0 from "./FinanceModule.vue?vue&type=style&index=0&id=4667c853&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4667c853",
  null
  
)

export default component.exports